import { HYDRATE_STATE } from '../../../integrations/hydration'
import { UPDATE_PRIMARY_FILTERS } from '../actions'

/**
 * @typedef {Object} PrimarySearchFilters Filters from "outside", can only be set with URL params
 *
 * @property {number[]} [relativeAscent] Ascent range relative to distance
 * @property {number[]} [relativeDescent] Descent range relative to distance
 */

/**
 * @typedef {PrimarySearchFilters|null} PrimarySearchFiltersState Filters from "outside", can only be set with URL params
 */

/**
 * @param {PrimarySearchFiltersState} initialState
 * @returns {(state: PrimarySearchFiltersState, action: Object) => PrimarySearchFiltersState}
 */
export default function primaryFiltersReducer(initialState) {
    return (state = initialState, action) => {
        switch (action.type) {
            case UPDATE_PRIMARY_FILTERS:
                if (action.changes) {
                    const primaryFilters = state ? {
                        ...state,
                        ...action.changes,
                    } : action.changes

                    for (const filter in primaryFilters) {
                        if (primaryFilters[filter]) {
                            // Contains at least one filter
                            return primaryFilters
                        }
                    }
                }

                return null

            case HYDRATE_STATE:
                return action.state.primaryFilters ? {
                    ...state,
                    ...action.state.primaryFilters,
                } : state

            default:
                return state
        }
    }
}
